import { render } from "./AlertBanner.vue?vue&type=template&id=4a159fdc&scoped=true"
import script from "./AlertBanner.vue?vue&type=script&lang=js"
export * from "./AlertBanner.vue?vue&type=script&lang=js"

import "./AlertBanner.vue?vue&type=style&index=0&id=4a159fdc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a159fdc"]])

export default __exports__